export const GRID = 16;
export const DIRECTIONS = { up: [0, -1], down: [0, 1], left: [-1, 0], right: [1, 0] };
export function freeFood(snake, random = Math.random) {
  const free = Array.from({ length: GRID * GRID }, (_, n) => [n % GRID, Math.floor(n / GRID)])
    .filter(p => !snake.some(s => s[0] === p[0] && s[1] === p[1]));
  return free.length ? free[Math.floor(random() * free.length)] : null;
}
export function initialSnake() {
  const snake = [[7, 8], [6, 8], [5, 8]];
  return { snake, direction: 'right', food: freeFood(snake), score: 0, done: false };
}
export function snakeStep(state, requested, random = Math.random) {
  if (state.done) return state;
  const old = DIRECTIONS[state.direction], next = DIRECTIONS[requested] || old;
  const direction = old[0] + next[0] === 0 && old[1] + next[1] === 0 ? state.direction : requested || state.direction;
  const delta = DIRECTIONS[direction], head = [state.snake[0][0] + delta[0], state.snake[0][1] + delta[1]];
  const eats = state.food && head[0] === state.food[0] && head[1] === state.food[1];
  const body = eats ? state.snake : state.snake.slice(0, -1);
  if (head.some(n => n < 0 || n >= GRID) || body.some(p => p[0] === head[0] && p[1] === head[1])) return { ...state, done: true };
  const snake = [head, ...body], food = eats ? freeFood(snake, random) : state.food;
  return { snake, direction, food, score: state.score + (eats ? 10 : 0), done: !food };
}
export function shuffledCards(random = Math.random) {
  const cards = [0, 1, 2, 3, 4, 5, 0, 1, 2, 3, 4, 5];
  for (let i = cards.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [cards[i], cards[j]] = [cards[j], cards[i]];
  }
  return cards;
}
export const memoryScore = moves => Math.max(100, 1200 - Math.max(0, moves - 6) * 40);
